export {
    default as Feedback,
    IFeedbackProps,
} from './feedback';
